define("shared/components/shared/mobile/open-app", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "shared/utils/platform-check", "shared/utils/redirect", "@ember/template-factory"], function (_exports, _component, _object, _component2, _platformCheck, _redirect, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"shared/utils/platform-check",0,"shared/utils/redirect",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @onClick={{this.openApp}}
    @variant={{if @type @type "outline"}}
    class={{if @class @class "o-—btn o--btn--block o--btn--primary"}}
    type="button"
    ...attributes
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{t "schedule.open_app"}}
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "zjz8I7Hs",
    "block": "[[[8,[39,0],[[16,0,[52,[30,1],[30,1],\"o-—btn o--btn--block o--btn--primary\"]],[24,4,\"button\"],[17,2]],[[\"@onClick\",\"@variant\"],[[30,0,[\"openApp\"]],[52,[30,3],[30,3],\"outline\"]]],[[\"default\"],[[[[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"    \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,4],[\"schedule.open_app\"],null]],[1,\"\\n\"]],[]]]],[]]]]]],[\"@class\",\"&attrs\",\"@type\",\"&default\"],false,[\"shared/ui/button\",\"if\",\"has-block\",\"yield\",\"t\"]]",
    "moduleName": "shared/components/shared/mobile/open-app.hbs",
    "isStrictMode": false
  });
  let OpenAppComponent = _exports.default = (_class = class OpenAppComponent extends _component2.default {
    get isIos() {
      return (0, _platformCheck.isIos)(navigator);
    }
    get appUrl() {
      return this.isIos ? 'https://apps.apple.com/ca/app/later/id784907999' : 'https://play.google.com/store/apps/details?id=me.latergram.latergramme';
    }
    openApp() {
      setTimeout(() => {
        window.open(this.appUrl, '_blank');
      }, 25);
      (0, _redirect.default)('later://');
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "openApp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openApp"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, OpenAppComponent);
});